var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Select from '@/common/components/Select/index.vue';
import { _post } from '@/common/request';
var CitySelect = /** @class */ (function (_super) {
    __extends(CitySelect, _super);
    function CitySelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.data = __spreadArrays(_this.status);
        _this.options = [];
        return _this;
    }
    CitySelect.prototype.statusChange = function (val) {
        this.data = __spreadArrays(val);
    };
    CitySelect.prototype.mounted = function () {
        this.initData();
    };
    /* method */
    CitySelect.prototype.initData = function () {
        var _this = this;
        _post('/property/place/cities', {}, false).then(function (res) {
            _this.options = res;
        });
    };
    CitySelect.prototype.changeHandle = function () {
        this.$emit('update:status', this.data);
        this.$emit('change', this.data);
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], CitySelect.prototype, "status", void 0);
    __decorate([
        Watch('status')
    ], CitySelect.prototype, "statusChange", null);
    CitySelect = __decorate([
        Component({
            components: {
                Select: Select,
            },
        })
    ], CitySelect);
    return CitySelect;
}(Vue));
export default CitySelect;
